export const IconWrapper = ({ children, search=false }) => (
  <span className="gz-search-icon">
    <span className="icon__wrapper">{children}</span>
  </span>
);